import React from "react";
import { Row, Col, Card, Form } from "antd";
import _ from "lodash";
import { formatRupiah } from "../../../Utils";

const FormItem = Form.Item;

const httpFromHttps = url => url.replace("http://", "https://");

const checkPhoto = (photo, group) => {
  if (photo.hasOwnProperty("imageUrl") && photo.imageUrl !== "") {
    if (!photo.imageUrl.uri) {
      if (group) {
        if (photo.name.includes(group) == false) {
          photo.name = `${photo.name} (${group})`;
        }
      }
      if (photo.name === "3rd Seat (jika ada wajib difoto)")
        photo.name = "3rd Seat";
      return photo;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

const checkMobbiPhoto = (photo, group) => {
  if (photo.hasOwnProperty("imageUrl") && photo.imageUrl !== "") {
    if (!photo.imageUrl.uri) {
      if (group) {
        if (photo.name.includes(group) == false) {
          photo.name = `${photo.name} (${group})`;
        }
      }
      if (photo.name === "3rd Seat (jika ada wajib difoto)")
        photo.name = "3rd Seat";
    }
  }

  return photo;
};

const trustPhoto = props => {
  let imgFilter = [];
  let notImages = [];

  if (props && props.photos) {
    for (let i = 0; i < props.photos.length; i++) {
      if (props.photos[i].name == "Odor") {
        var notImage = props.photos[i];
        var val = _.find(notImage.list, { value: notImage.value });
        if (val) {
          notImage.value = val.name;
          notImages.push(notImage);
        }
      }
      if (props.photos[i].list) {
        for (let j = 0; j < props.photos[i].list.length; j++) {
          const image = checkPhoto(
            props.photos[i].list[j],
            props.photos[i].fieldName || props.photos[i].name
          );
          if (image) imgFilter.push(image);
          if (!props.photos[i].list[j].hasOwnProperty("imageUrl")) {
            if (props.photos[i].name != "Odor") {
              var notImage = props.photos[i].list[j];
              notImage.name = `${notImage.name} (${
                props.photos[i].name || props.photos[i].fieldName
              })`;
              notImages.push(notImage);
            }
          }
        }
      } else {
        if (
          props.photos[i].imageUrl !== "" &&
          props.photos[i].hasOwnProperty("imageUrl")
        ) {
          const image = checkPhoto(props.photos[i], null);
          if (image) imgFilter.push(image);
        }
      }
    }
    const data =
      props.photos && props.tab != "Harga"
        ? props.photos.filter(
            photo =>
              photo.hasOwnProperty("imageUrl") &&
              photo.imageUrl !== "" &&
              !photo.imageUrl.uri
          )
        : null;
  }

  return props.photos ? (
    props.tab != "Harga" ? (
      <Row>
        <Col xs={24} md={24}>
          <Card>
            {(props.tab == "Frame" ||
              props.tab == "Engine" ||
              props.tab == "Exterior" ||
              props.tab == "Interior") &&
              notImages.map((photo, index) => (
                <FormItem label={photo.name} key={index}>
                  <span className="ant-form-text">{photo.value}</span>
                </FormItem>
              ))}
          </Card>
        </Col>

        {imgFilter.map((photo, index) => (
          <Col key={index} xs={24} md={12}>
            <Card title={photo.name ? photo.name : photo.fieldName}>
              {(photo.name == "Dashboard" || photo.name == "Steer Wheel") && (
                <FormItem label="Defect">
                  <span className="ant-form-text">
                    {photo.cheked ? "Ya" : "Tidak"}
                  </span>
                </FormItem>
              )}

              {photo.name == "Buku Service" && (
                <FormItem label="Ada">
                  <span className="ant-form-text">
                    {photo.cheked ? "Ya" : "Tidak"}
                  </span>
                </FormItem>
              )}

              {photo.hasOwnProperty("damage") && photo.damage && (
                <FormItem label="Damage">
                  <span className="ant-form-text">{photo.damage}</span>
                </FormItem>
              )}

              {photo.hasOwnProperty("damage") &&
                photo.damage &&
                photo.level && (
                  <FormItem label="Level">
                    <span className="ant-form-text">{photo.level}</span>
                  </FormItem>
                )}
              <img
                id={
                  photo.name
                    ? photo.name + props.appraisalId
                    : photo.fieldName + props.appraisalId
                }
                src={httpFromHttps(photo.imageUrl)}
                width="100%"
                alt="img_doc"
                onClick={() => props.photoModal(true, photo)}
              />
              <FormItem label="Notes">
                <span className="ant-form-text">{photo.notes}</span>
              </FormItem>
            </Card>
          </Col>
        ))}
      </Row>
    ) : (
      <Row>
        <Col xs={24} md={24}>
          <Card>
            <FormItem label="Range Harga" key="1">
              <span className="ant-form-text">{`${formatRupiah(
                props.priceMin
              )} s.d ${formatRupiah(props.photos.hargaMobil)}`}</span>
            </FormItem>
            <FormItem label="Biaya Pemotongan Appraisal" key="2">
              {props.photos.kendaraan[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.overView[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoEngine[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoExterior[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoFrame[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoInterior[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}
            </FormItem>
            <FormItem label="Harga Penawaran" key="3">
              <span className="ant-form-text">
                {formatRupiah(props.photos.hargaFinalAfterNego)}
              </span>
            </FormItem>
            <FormItem label="Ruang Nego" key="4">
              <span className="ant-form-text">
                {formatRupiah(props.photos.ruangNego)}
              </span>
            </FormItem>
            <FormItem label="Harga MRP" key="5">
              <span className="ant-form-text">
                {formatRupiah(props.photos.hargaFinal)}
              </span>
            </FormItem>
          </Card>
        </Col>
      </Row>
    )
  ) : (
    "tidak ada gambar"
  );
};

const getTabPhoto = data => {
  let objFilter = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].list) {
      for (let j = 0; j < data[i].list.length; j++) {
        if (
          data[i].list[j].hasOwnProperty("imageUrl") &&
          data[i].list[j].imageUrl != ""
        ) {
          let value = data[i].list[j].value;
          if (value == 5) {
            const image = checkMobbiPhoto(
              data[i].list[j],
              data[i].fieldName || data[i].name
            );
            objFilter.push(image);
          }
        }
      }
    } else {
      if (data[i].hasOwnProperty("imageUrl") && data[i].imageUrl != "") {
        let value = data[i].value;
        if (value == 5) {
          const image = checkMobbiPhoto(data[i], null);
          objFilter.push(image);
        }
      }
    }
  }

  return objFilter;
};

const getOtherPhoto = props => {
  let objFilter = [];

  ["photoFrame", "photoInterior", "photoExterior"].map(v => {
    if (props.photos[v]) {
      objFilter = [...objFilter, ...getTabPhoto(props.photos[v])];
    }
  });

  return objFilter;
};

const getMobbiPhoto = props => {
  let photoOnly = [
    "STNK",
    "Mesin",
    "Interior Depan",
    "Eksterior Depan",
    "Eksterior Belakang",
  ];
  let objFilter = [];

  ["photoMobbi"].map(v => {
    if (props.photos[v]) {
      let data = props.photos[v];
      for (let i = 0; i < data.length; i++) {
        if (props.tab == "Foto dari Mobbi88") {
          if (photoOnly.includes(data[i].name) == false) continue;
        } else {
          if (photoOnly.includes(data[i].name) == true) continue;
        }

        if (data[i].type === "select") {
          if (
            data[i].value == 1 ||
            !["", 0].includes(data[i].actionCostEstimation) ||
            data[i].notes != "" ||
            data[i].imageUrl != ""
          ) {
            const image = checkMobbiPhoto(data[i], null);
            objFilter.push(image);
          }
        } else if (data[i].type == "photo") {
          if (data[i].imageUrl && data[i].imageUrl != "") {
            const image = checkMobbiPhoto(data[i], null);
            objFilter.push(image);
          }
        }
      }
    }
  });

  return objFilter;
};

const mobbiPhoto = props => {
  let objFilter = [];
  let notImages = [];

  if (props.tab == "Other") {
    objFilter = getOtherPhoto(props);
  } else if (
    ["Rekomendasi tambahan Mobbi88", "Foto dari Mobbi88"].includes(props.tab)
  ) {
    objFilter = getMobbiPhoto(props);
  } else if (props && props.photos) {
    for (let i = 0; i < props.photos.length; i++) {
      if (props.photos[i].list) {
        for (let j = 0; j < props.photos[i].list.length; j++) {
          if (props.photos[i].list[j].name == "Banjir") continue;
          if (props.photos[i].list[j].hasOwnProperty("imageUrl")) {
            let value = props.photos[i].list[j].value;
            if (value == 1 || value == 3) {
              const image = checkMobbiPhoto(
                props.photos[i].list[j],
                props.photos[i].fieldName || props.photos[i].name
              );
              objFilter.push(image);
            }
          }
        }
      } else {
        if (props.photos[i].hasOwnProperty("imageUrl")) {
          let value = props.photos[i].value;
          if (value == 1 || value == 3) {
            const image = checkMobbiPhoto(props.photos[i], null);
            objFilter.push(image);
          }
        }
      }
    }
  }

  return props.photos ? (
    props.tab != "Harga" ? (
      <Row>
        <Col xs={24} md={24}>
          <Card>
            {(props.tab == "Frame" ||
              props.tab == "Engine" ||
              props.tab == "Exterior" ||
              props.tab == "Interior") &&
              notImages.map((photo, index) => (
                <FormItem label={photo.name} key={index}>
                  <span className="ant-form-text">{photo.value}</span>
                </FormItem>
              ))}
          </Card>
        </Col>

        {objFilter.map((photo, index) => (
          <Col key={index} xs={24} md={12}>
            <Card title={photo.name ? photo.name : photo.fieldName}>
              {(photo.name == "Dashboard" || photo.name == "Steer Wheel") && (
                <FormItem label="Defect">
                  <span className="ant-form-text">
                    {photo.cheked ? "Ya" : "Tidak"}
                  </span>
                </FormItem>
              )}

              {photo.name == "Buku Service" && (
                <FormItem label="Ada">
                  <span className="ant-form-text">
                    {photo.cheked ? "Ya" : "Tidak"}
                  </span>
                </FormItem>
              )}

              {photo.hasOwnProperty("damage") && photo.damage && (
                <FormItem label="Damage">
                  <span className="ant-form-text">{photo.damage}</span>
                </FormItem>
              )}

              {photo.hasOwnProperty("damage") &&
                photo.damage &&
                photo.level && (
                  <FormItem label="Level">
                    <span className="ant-form-text">{photo.level}</span>
                  </FormItem>
                )}
              {photo.imageUrl && photo.imageUrl != "" ? (
                <img
                  id={
                    photo.name
                      ? photo.name + props.appraisalId
                      : photo.fieldName + props.appraisalId
                  }
                  src={httpFromHttps(photo.imageUrl)}
                  width="100%"
                  alt="img_doc"
                  onClick={() => props.photoModal(true, photo)}
                />
              ) : (
                <div>Tidak ada gambar!</div>
              )}

              {props.tab != "Foto dari Mobbi88" && (
                <FormItem label="Notes">
                  <span className="ant-form-text">{photo.notes}</span>
                </FormItem>
              )}

              {props.isMobbi && photo.type == "select" && (
                <FormItem label="Action Cost Estimation">
                  <span className="ant-form-text">
                    {formatRupiah(photo.actionCostEstimation) || 0}
                  </span>
                </FormItem>
              )}
            </Card>
          </Col>
        ))}
      </Row>
    ) : (
      <Row>
        <Col xs={24} md={24}>
          <Card>
            <FormItem label="Range Harga" key="1">
              <span className="ant-form-text">{`${formatRupiah(
                props.priceMin
              )} s.d ${formatRupiah(props.photos.hargaMobil)}`}</span>
            </FormItem>
            <FormItem label="Biaya Pemotongan Appraisal" key="2">
              {props.photos.kendaraan[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.overView[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoEngine[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoExterior[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoFrame[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}

              {props.photos.photoInterior[0].map((item, idx) => (
                <FormItem label={`- ${item.name}`} key={idx}>
                  <span className="ant-form-text">
                    {formatRupiah(item.value)}
                  </span>
                </FormItem>
              ))}
            </FormItem>
            <FormItem label="Harga Penawaran" key="4">
              <span className="ant-form-text">
                {formatRupiah(props.photos.hargaFinalAfterNego)}
              </span>
            </FormItem>
            <FormItem label="Ruang Nego" key="5">
              <span className="ant-form-text">
                {formatRupiah(props.photos.ruangNego)}
              </span>
            </FormItem>
            <FormItem label="Harga MRP" key="6">
              <span className="ant-form-text">
                {formatRupiah(props.photos.hargaFinal)}
              </span>
            </FormItem>
          </Card>
        </Col>
      </Row>
    )
  ) : (
    "tidak ada gambar"
  );
};

const PhotoDocument = props => {
  console.log(props.isMobbi, "isMobbi");
  if (props.isMobbi) {
    return mobbiPhoto(props);
  }
  return trustPhoto(props);
};

export default PhotoDocument;



// WEBPACK FOOTER //
// src/components/Dashboard/Appraisal/PhotoComponent/PhotoDocument.js